// src/components/common/StatusToggle.js
import React from 'react';
import styles from './StatusToggle.module.css';

/**
 * Durum göstergesi ve aksiyonu tek kontrolde birleştirir:
 * anahtarın konumu = mevcut (veya kaydedilmeyi bekleyen) durum.
 *
 * Ayrı bir "Aktif/Pasif" rozeti + "Aktif Yap/Pasif Yap" butonu ikilisi
 * aynı bilgiyi iki kez, üstelik ters yönde gösterdiği için bunun yerine kullanılır.
 */
const StatusToggle = ({
    label,
    checked,
    saving = false,
    disabled = false,
    onChange,
    onText = 'Aktif',
    offText = 'Pasif',
    savingText = 'Kaydediliyor…',
}) => (
    <label className={`${styles.toggle} ${saving ? styles.saving : ''} ${disabled && !saving ? styles.disabled : ''}`}>
        <input
            type="checkbox"
            className={styles.input}
            checked={!!checked}
            disabled={saving || disabled}
            onChange={onChange}
            aria-label={label}
        />
        <span className={styles.track} aria-hidden="true">
            <span className={styles.thumb} />
        </span>
        <span className={`${styles.text} ${checked ? styles.textOn : ''}`}>
            {saving ? savingText : checked ? onText : offText}
        </span>
    </label>
);

export default StatusToggle;
